import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/services/loading.service';
import { ToastrService } from 'ngx-toastr';
import { DxFormComponent } from 'devextreme-angular';
import { BrokerRegistrationService } from 'src/app/services/brokers/broker-registration.service';
import { BrokerRegistrationModel } from 'src/app/models/broker-registration/broker-registration.model';

@Component({
  selector: 'app-broker-register',
  standalone: false,
  templateUrl: './broker-register.component.html',
  styleUrl: './broker-register.component.scss',
})
export class BrokerRegisterComponent {
  @ViewChild('form', { static: false }) 
  form!: DxFormComponent;

  isRegistered: boolean = false;
  formData: BrokerRegistrationModel = {
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    phone: null,
    culture: '',
    password: '',
    passwordConfirmation: '',
  };

  constructor(
    private loadingService: LoadingService,
    private registrationService: BrokerRegistrationService,
    private toastrService: ToastrService,
    public translateService: TranslateService,
  ) {}

  
  passwordComplexityCheck = (e: any) => {
    const value: string = e.value || '';
    const minLength = 10;
    const hasUpper = /[A-Z]/.test(value);
    const hasLower = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecial = /[!@#$%^&*\-_+=?.,:;'()€]/.test(value);
    return value.length >= minLength && hasUpper && hasLower && hasNumber && hasSpecial;
  };

  repeatPasswordValidation = (e: any) => {
    return e.value === this.formData.password;
  };

  register(): void {
    const isValid = 
      this.form.instance.validate().isValid;

    if (!isValid) {
      this.toastrService.error(
        this.translateService.instant(
          'VALIDATIONS.VALUES-NOT-VALID'
        )
      );
      return;
    }

    const lang = this.translateService.currentLang || 'en';
    this.formData.culture = lang;

    this.loadingService
      .load(this.registrationService.register(this.formData))
      .subscribe({
        next: (result) => {
          if (result.isAlreadyRegistered) {
            this.toastrService.warning(
              this.translateService.instant(
                'BROKER-REGISTRATION.ALREADY-REGISTERED'
              )
            );
            return;
          }

          if (result.isRegistrationPending) {
            this.toastrService.info(
              this.translateService.instant(
                'BROKER-REGISTRATION.REGISTRATION-PENDING'
              )
            );
            return;
          }

          this.isRegistered = true;
        },
        error: (error) => {
          console.error('Error registering:', error);
        }
      });
  }
}